import { Component } from '@angular/core'

@Component({
  selector: 'kit-antd-tabs-example',
  templateUrl: './tabs.component.html',
})
export class KitAntdTabsExampleComponent {}
